export class MgoErrorProcessing {
  id: number;
  nombreDeArchivo: string;
  nroShipper: number;
  transporteError: string;
  destinatarioError: string;
  dockError: string;
  dunsError: string;
  fecProceso:  Date | null = new Date();

  /**
   * This maps the data obj received from http client, which
   * contains fecProceso as a date, to a MgoErrorProcessing.ts obj with fecProceso
   * as a date for compatibility with our column filters.
   * @param data The data received from HttpClient.
   */
  static transformData(data: any): MgoErrorProcessing {
    let mgoErrorProcessingData = new MgoErrorProcessing();
    mgoErrorProcessingData.id = data.id;
    mgoErrorProcessingData.nombreDeArchivo = data.nombreDeArchivo;
    mgoErrorProcessingData.nroShipper = data.nroShipper;
    mgoErrorProcessingData.transporteError = data.transporteError;
    mgoErrorProcessingData.destinatarioError = data.destinatarioError;
    mgoErrorProcessingData.dockError = data.dockError;
    mgoErrorProcessingData.dunsError = data.dunsError;
    mgoErrorProcessingData.fecProceso = data.fecProceso != null ? new Date(data.fecProceso) : null;

    return mgoErrorProcessingData;
  }
}


